import React from "react";
import { Wrapper, Title, Content } from "./Theme";
export const PreviewTemplate = ({ selectedTemplate, campaignEditData }) => {
  console.log(
    "selectedTemplate",
    selectedTemplate,
    "campaignEditData",
    campaignEditData
  );
  const createMarkup = () => {
    return {
      __html:
        selectedTemplate?.htmlContent ||
        campaignEditData?.template?.htmlContent,
    };
  };

  return (
    <Wrapper>
      <Title>Select Template</Title>
      <span>Preview Template</span> <br />
      <Content>
        <div dangerouslySetInnerHTML={createMarkup()} />
      </Content>
    </Wrapper>
  );
};
